// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "io.ozonewallet",
    name: "OzoneWallet",
    homepage: "https://ozonewallet.io/",
    image_id: "4eb57479-515a-463a-9fcb-c20e9cc60c00",
    app: {
        browser: null,
        ios: null,
        android: "https://play.google.com/store/apps/details?id=com.chiatk.apps.ozone1",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "chiawallet://ozonewallet.io",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map